module.exports = __webpack_public_path__ + "static/CaseStudy_Libra-521ad33d86a07c0e00c37826181976d1.pdf";